import { Outlet } from '../components/Outlet';
export const createRoutesFromArray = (partialRouteObjects) => {
    return partialRouteObjects.map((partialRoute) => {
        const route = {
            path: partialRoute.path || '/',
            caseSensitive: partialRoute.caseSensitive === true,
            element: partialRoute.element || Outlet,
        };
        if (partialRoute.children) {
            route.children = createRoutesFromArray(partialRoute.children);
        }
        return route;
    });
};
